
import GwProgramCard from '~/patterns/atoms/card/presets/program-card';
import GwCourseList from '~/patterns/organisms/course-list/course-list';

export default {
    components: {
        GwCourseList,
        GwProgramCard,
    },
    props: {
        courses: {
            type: Array,
            default: () => { return []; },
        },
        highlightItem: {
            type: String,
            default: null,
        }
    },
    computed: {
        programs() {
            const grouped = this.courses.reduce((result, course) => {
                if (!course.programs || !course.programs.length) {
                    return result;
                }

                course.programs.forEach((program) => {
                    const key = program.id;

                    if (!result[key]) {
                        result[key] = {
                            program,
                            courses: []
                        };
                    }

                    result[key].courses.push(course);
                });

                return result;
            }, {});

            const list = Object.values(grouped);

            if (this.highlightItem) {
                list.sort((a, b) => {
                    if (a.program.slug === this.highlightItem) {
                        return -1;
                    }

                    if (b.program.slug === this.highlightItem) {
                        return 1;
                    }

                    return 0;
                });
            }

            return list;
        }
    }
};
